'use client';

import { useAbsolutePath } from '@svenskaspelab/nova-core/nextjs/cms';
import Link from 'next/link';

import { paths } from '../constants';
const { PERSONAL_INFO, TERMS, RULES } = paths;

import { TabLink, TabLinks } from '@svenskaspelab/ui/react/tabs-link';

function TirNav({ activePath }: { activePath: string }) {
  const tabs = [
    { label: 'Villkor', path: useAbsolutePath(TERMS) },
    { label: 'Personuppgifter', path: useAbsolutePath(PERSONAL_INFO) },
    { label: 'Spelregler', path: useAbsolutePath(RULES) },
  ] as const;

  return (
    <TabLinks context="surface" className="mb-4" stretchItems>
      {tabs.map(({ label, path }) => (
        <TabLink key={path} path={path} isActive={activePath === label} render={<Link href={path} prefetch={false} />}>
          {label}
        </TabLink>
      ))}
    </TabLinks>
  );
}

export default TirNav;
